export default function SidebarSquareIcon({ size = 16, darkMode }) {
  const outer = darkMode ? '#ffffff' : '#000000';
  const inner = darkMode ? '#333333' : '#ffffff';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer square */}
      <rect width="20" height="20" rx="2" fill={outer} />

      {/* Inner square */}
      <rect x="7" y="3" width="10" height="14" fill={inner} />
    </svg>
  );
}
